import { Route, Routes } from 'react-router-dom'
import { FormAddressPage } from '../subPages/formAddressPage'
import { EventInfoForm } from './eventInfoForm'

export const EventInfoRoutes = () => {
    return (
        <Routes>
            <Route key={'editItinerary'} index element={<EventInfoForm />} />
            <Route
                key={'address'}
                path="address"
                element={<FormAddressPage fieldName="OSMAddress" />}
            />
        </Routes>
    )
}
